import React from 'react';
import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import left from '../../assets/images/left.svg';
import right from '../../assets/images/right.svg';
import e from '../../assets/images/E.svg';

const BP2 = '@media (max-width: 825px)';
const BP3 = '@media (max-width: 594px)';
const BP4 = '@media (max-width: 740px)';
const BP5 = '@media (max-width: 491px)';
const BP6 = '@media (max-width: 386px)';

const sx = {
  root: {
    margin: 'auto',
    mt: '59px',
    width: '100%',
    maxWidth: '728px',
    borderRadius: '50%',
    display: 'flex',
    flexDirection: 'row',
    gap: '0px 10px',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: '1',
  },
  text: {
    fontSize: '50px',
    fontFamily: 'amallia',
    maxWidth: '100%',
    lineHeight: '48px',
    zIndex: '2',
    color: '#3F4B0C',
    [BP3]: {
      fontSize: '40px',
    },
    [BP5]: {
      fontSize: '30px',
    },
    [BP6]: {
      fontSize: '23px',
    },
  },
  titleBackground: {
    position: 'absolute',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  backgroundTitle: {
    fontSize: '122px',
    fontFamily: 'amallia',
    color: '#3F4B0C',
    marginTop: '60px',
    opacity: '0.3',
    zIndex: '1',
    [BP3]: {
      fontSize: '90px',
    },
  },
};

const Title = forwardRef(({ text, style }, ref) => {
  // console.log(ref);
  return (
    <>
      <Box sx={sx.container}>
        <Box sx={sx.root} ref={ref}>
          <img
            src={left}
            style={{ width: '11%', ...style }}
            alt="title_decoration"
          />
          <Typography align="center" sx={sx.text}>
            {text}
          </Typography>
          <img
            src={right}
            style={{ width: '11%', ...style }}
            alt="title_decoration"
          />
        </Box>
        <Box sx={sx.titleBackground}>
          {/* <img
            src={e}
            style={{ width: '90%', ...style, marginTop: '100px' }}
            alt="title"
          /> */}
          <Typography sx={sx.backgroundTitle}>E</Typography>
        </Box>
      </Box>
    </>
  );
});
Title.propTypes = {
  text: PropTypes.string.isRequired,
};
export default Title;
